// Boostrap offcanvas
( function($, waTheme) {

    var BootstrapOffcanvas = (function ($) {

        BootstrapOffcanvas = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options['$wrapper'];

            // VARS
            that.modal_id = options['modal_id'];

            // DYNAMIC VARS

            // EVENTS
            that.bindEvents();
        };

        BootstrapOffcanvas.prototype.bindEvents = function () {
            var that = this;

            $(document).on("click", `.${that.modal_id}Show, a[href="#${that.modal_id}Show"]`, function (event) {
                event.preventDefault();
                that.$wrapper.offcanvas("show");
            });
        }

        return BootstrapOffcanvas;

    })($);

    waTheme.init.site.BootstrapOffcanvas = BootstrapOffcanvas;

})(jQuery, window.waTheme);